import React, { useState, useEffect } from 'react';
import { FiMapPin, FiExternalLink } from 'react-icons/fi';
import { gymAPI } from '../../api/services';
import { useTranslation } from 'react-i18next';

const IMAGES = [
  'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80',
  'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=400&q=80',
  'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=400&q=80',
  'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&q=80',
  'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400&q=80',
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&q=80',
];

const GymsPage = () => {
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    gymAPI.getAll()
      .then(r => setGyms(r.data?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <img src="/illustrations/gym.png" alt="Gyms" className="page-header-illustration" />
          <span className="section-label">{t('gyms_page.label')}</span>
          <h1>{t('gyms_page.title')}</h1>
          <p>{t('gyms_page.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : gyms.length === 0 ? (
            <div className="empty-state">
              <div className="icon">🏟️</div>
              <h3>{t('gyms_page.no_gyms')}</h3>
              <p>{t('gyms_page.updating')}</p>
            </div>
          ) : (
            <div className="grid-3">
              {gyms.map((gym, i) => (
                <div key={gym.id} className="card gym-card">
                  <img src={gym.mediaUrl || IMAGES[i % IMAGES.length]} alt={gym.name} className="card-img" />
                  <div className="card-body">
                    <h3 style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: 5 }}>{gym.name}</h3>
                    {gym.sportTypeName && <span className="gym-badge">{gym.sportTypeName}</span>}
                    <div className="gym-meta">
                      <FiMapPin /> {gym.location}
                    </div>
                    {gym.trainerName && (
                      <p style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: 5 }}>
                        {t('fields.trainer')}: {gym.trainerName}
                      </p>
                    )}
                    {gym.mapLink && (
                      <a href={gym.mapLink} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--accent)', fontSize: '0.8rem', marginTop: 6, fontWeight: 600 }}>
                        <FiExternalLink /> {t('gyms_page.view_on_map')}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default GymsPage;
